// src/admin/utils/adminStyles.js

export const getAdminStyles = (isDark) => ({
  page: isDark
    ? "bg-black text-white"
    : "bg-gray-50 text-gray-900",

  card: isDark
    ? `
      bg-white/5
      border
      border-white/10
      backdrop-blur-xl
      rounded-3xl
    `
    : `
      bg-white
      border
      border-gray-200
      rounded-3xl
      shadow-sm
    `,

  sidebar: isDark
    ? `
      bg-black
      border-r
      border-white/10
    `
    : `
      bg-white
      border-r
      border-gray-200
    `,

  navbar: isDark
    ? `
      bg-black/80
      border-b
      border-white/10
      backdrop-blur-xl
    `
    : `
      bg-white/90
      border-b
      border-gray-200
      backdrop-blur-xl
    `,

  input: isDark
    ? `
      bg-white/5
      border-white/10
      text-white
    `
    : `
      bg-white
      border-gray-300
      text-gray-900
    `,
});